import BlogTwoContainer from "./container/BlogTwoContainer";
export default BlogTwoContainer;
